/**
 * Created by asiulik on 19.05.2017.
 */

define(['jquery'], function ($) {

    var styles = {};

    var initialScripts = {};
    var lastScript = null;
    var lastStyle = null;

    function PageAssets() {

        this.filterOnlyOwnAssets($('script[src]'), 'src').each(function (index, script) {
            initialScripts[$(script).attr('src')] = script;
            lastScript = script;
        });

        this.filterOnlyOwnAssets($('link[rel="stylesheet"]'), 'href').each(function (index, style) {
            styles[$(style).attr('href')] = style;
            lastStyle = style;
        });

    }

    PageAssets.prototype.handleNewAssets = function ($data) {
        // this.handleNewStyles($data);
        this.handleNewScripts($data);
    };

    PageAssets.prototype.handleNewScripts = function ($data) {

        // this.filterOnlyOwnAssets($data.filter('script[src]'), 'src').each(function (index, script) {
        var scriptsToHandleByAjax = [];

        $data.filter('script').each(function (index, script) {

            var $script = $(script);

            // if (typeof(initialScripts[$script.attr('src')]) === 'undefined' || $(script).attr('data-ajax-reload')) {
            if ($script.attr('data-ajax-reload')) {

                if($script.attr('data-ajax-ajax')){

                    scriptsToHandleByAjax.push($script.get(0));

                } else {
                    $script.insertAfter(lastScript);
                    lastScript = script;
                }


            } else if ($script.attr('data-ajax-load-once')) {

                var src = $(script).attr('src');

                if (src && !loadedScripts[src]) {
                    loadedScripts[src] = script;
                    $script.insertAfter(lastScript);
                    lastScript = script;
                }
            }
        });

        if(scriptsToHandleByAjax.length){
            this.hangleAjaxScripts(scriptsToHandleByAjax);
        }

    };

    PageAssets.prototype.hangleAjaxScripts = function(scriptsLoadAjaxCollection){

        var _this = this;

        if(!scriptsLoadAjaxCollection.length) return

        $.get(scriptsLoadAjaxCollection[0].src).then(function(response){
            $.globalEval(response);
            scriptsLoadAjaxCollection.splice(0, 1);
            _this.hangleAjaxScripts(scriptsLoadAjaxCollection);
        });

    };

    PageAssets.prototype.handleNewStyles = function ($data) {

        this.filterOnlyOwnAssets($data.filter('link[rel="stylesheet"]'), 'href').each(function (index, style) {

            if (typeof(styles[$(style).attr('href')]) === 'undefined') {
                $(style).insertAfter(lastStyle);
                lastStyle = style;
            }

        });

    };

    PageAssets.prototype.filterOnlyOwnAssets = function ($assets, attr) {

        return $assets.filter(function (index, asset) {

            var src = $(asset).attr(attr);
            var dontTouchAttr = $(asset).attr('not-handle-by-ajax');

            if (src.indexOf('http') !== 0) {
                return false;
            }

            if (src.indexOf(window.location.protocol + '//' + window.location.host) !== 0) {
                return false;
            }

            if (dontTouchAttr) {
                return false;
            }

            return true;

        });

    };

    var instance = null;

    var getInstance = function () {

        if (!instance) {
            instance = new PageAssets();
        }

        return instance;

    };

    return getInstance;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/page/pageAssets.js